import React from 'react'
import { links } from 'common/helpers'

import Link from 'components/ui/Link/Link'

import messages from './messages'
import s from './FooterLinks.scss'


const FooterLinks = () => {
  const items = [
    { title: messages.about, to: links.team },
    { title: messages.shopPerfumes, toOLD: links.perfumes },
    { title: messages.shopColognes, toOLD: links.colognes },
    { title: messages.help, redirect: links.faq },
  ]

  return (
    <div className={s.links}>
      {
        items.map((link, index) => (
          <Link key={index} className={s.link} customColor {...link} />
        ))
      }
    </div>
  )
}


export default FooterLinks
